import { RainbowKitProvider, type Locale } from "@rainbow-me/rainbowkit";
import { QueryClientProvider } from "@tanstack/react-query";
import type { PropsWithChildren } from "react";
import { useTranslation } from "react-i18next";
import { WagmiProvider } from "wagmi";

import { normalizeLanguage } from "@/i18n";
import { queryClient } from "@/lib/queryClient";
import { WEB3_CHAIN } from "@/lib/web3/chain";
import { oursRainbowKitTheme } from "@/lib/web3/rainbowKitTheme";
import { wagmiConfig } from "@/lib/web3/wagmiConfig";

export default function Web3Provider({ children }: PropsWithChildren) {
  const { i18n } = useTranslation();
  const locale: Locale =
    normalizeLanguage(i18n.resolvedLanguage) === "en-US" ? "en-US" : "zh-CN";

  return (
    <WagmiProvider config={wagmiConfig}>
      <QueryClientProvider client={queryClient}>
        <RainbowKitProvider
          initialChain={WEB3_CHAIN}
          locale={locale}
          modalSize="compact"
          theme={oursRainbowKitTheme}
        >
          {children}
        </RainbowKitProvider>
      </QueryClientProvider>
    </WagmiProvider>
  );
}
